import { APIResponseType } from "@/shared/types";
import { createGetApiHook } from "./apiHooks";

const getAllBookings = (queryParams: Record<string, any> = {}): string => {
  const fullParams = {
    ...queryParams,
    ...(queryParams.card_id && { card_id: queryParams.card_id }),
    offset: queryParams.offset ?? 0,
    limit: queryParams.limit ?? 1000,
  };

  const queryString = new URLSearchParams(fullParams).toString();
  return `/bookings?${queryString}`;
};

export const useGetBookings = createGetApiHook<APIResponseType<any>, any>(getAllBookings);
